<div class="page-container">
    <div class="page-title-wrapper">
        <div>{{ 'exhaust-settings.title-1' | translate }}</div>
        <div class="page-title">
            {{ 'exhaust-settings.title-2' | translate }}
        </div>
    </div>
    <div *ngFor="let setting of currentSettings" class="settings-container">
        <div class="settings-title-wrapper">
            <div class="settings-title-container">
                <div class="settings-title-row">
                    <div data-cy="exh-gas-setting-cylinder-group-name">
                        {{ setting.title }}
                    </div>
                    <div class="num-channels-text" data-cy="exh-gas-setting-cylinder-group-no-of-cylinders">
                        {{
                            'exhaust-setting.title.chanels.' + (setting.settingChannels?.length === 1 ? 'one' : 'other')
                                | translate
                                    : {
                                          num: setting.settingChannels?.length || 0,
                                      }
                        }}
                    </div>
                </div>
                <div class="settings-title-row">
                    <div class="avg-title">
                        {{ 'exhaust-setting.title.temp-avg' | translate }}
                    </div>
                    <ng-container *ngIf="setting.averageChannelData">
                        <div
                            class="avg-channel-text"
                            data-cy="exh-gas-setting-temp-avg-channel-name"
                            [class.disabled]="!userCanEdit"
                            (click)="selectAvgChannel(setting)">
                            {{ getChannelName(setting.averageChannelData) }}
                        </div>
                        <button class="clear-wrapper" (click)="removeAvgChannel(setting)" [disabled]="!userCanEdit">
                            <mat-icon svgIcon="delete" class="options-icon" />
                            <span class="avg-channel-text clear">
                                {{ 'exhaust-setting.clear' | translate }}
                            </span>
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!setting.averageChannelData">
                        <div
                            class="avg-channel-text error-button"
                            data-cy="exh-gas-setting-temp-avg-select-channel-button"
                            (click)="selectAvgChannel(setting)"
                            [class.disabled]="!userCanEdit">
                            {{ 'exhaust-setting.select' | translate }}
                        </div>
                        <mat-icon
                            svgIcon="save-error"
                            class="info-icon"
                            (mouseenter)="isAvgInfoMessageVisible = setting"
                            (mouseleave)="isAvgInfoMessageVisible = null" />
                        <ng-container *ngIf="isAvgInfoMessageVisible == setting">
                            <div #infoMessage class="info-message-container">
                                <div>
                                    {{ 'exhaust-setting.title.temp-avg.info-1' | translate }}
                                </div>
                                <br />
                                <div>
                                    {{ 'exhaust-setting.title.temp-avg.info-2' | translate }}
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <mat-icon
                svgIcon="more-options"
                class="options-icon"
                [class.disabled]="!userCanEdit"
                (click)="openOptions(setting); $event.stopPropagation()" />
            <ng-container *ngIf="optionsSettingOpen == setting">
                <div class="more-options-container" #otherOptions>
                    <div class="option-text" (click)="editSetting(setting)">
                        {{ 'exhaust-settings.option.edit' | translate }}
                    </div>
                    <div class="option-text" [class.disabled]="isAddDisabled()" (click)="duplicateSetting(setting)">
                        {{ 'exhaust-settings.option.duplicate' | translate }}
                    </div>
                    <div class="option-text" (click)="deleteSetting(setting)">
                        {{ 'exhaust-settings.option.delete' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
        <app-exhaust-setting [setting]="setting" (exhaustUpdated)="onExhaustUpdated()"></app-exhaust-setting>
    </div>

    <div class="add-settings-row">
        <div class="add-button" [class.disabled]="isAddDisabled()" (click)="addSetting()">
            {{ 'exhaust-settings.add' | translate }}
        </div>
        <div (click)="addSetting()">
            {{ 'exhaust-settings.groups-length' | translate: { num: currentSettings?.length || 0 } }}
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading">
    <div class="loading-container">
        <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
    </div>
</ng-container>

<app-confirmation-window
    #removeAvgConfirmation
    [mainLabel]="'exhaust-settings.remove.source'"
    [discardLabel]="'exhaust-settings.remove.source.cancel'"
    [saveLabel]="'exhaust-settings.remove.source.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>
